import { inject } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { ActivatedRouteSnapshot, ResolveFn, Routes } from '@angular/router';
import UserRouteAccessService from 'app/core/auth/user-route-access-service';
import {
  Observable, of
} from 'rxjs';
import {
  filter, map
} from 'rxjs/operators';
import {
  NotificationMessageRx, INotificationMessageRx
} from 'app/shared/model/notification-message-rx.model';
import NotificationMessageRxService from './notification-message-rx.service';
import NotificationMessageRxComponent from './notification-message-rx.component';
import ResolvePagingParams from '../resolve-paging-params.service';

export const NotificationMessageRxResolve: ResolveFn<INotificationMessageRx> = (route: ActivatedRouteSnapshot): Observable<INotificationMessageRx> => {
  const { id } = route.params;
  if (id) {
    return inject(NotificationMessageRxService).find(id).pipe(
      filter((response: HttpResponse<NotificationMessageRx>) => response.ok),
      map((notificationMessage: HttpResponse<NotificationMessageRx>) => notificationMessage.body)
    );
  }
  return of(new NotificationMessageRx());
};

export const notificationMessageRoute: Routes = [
  {
    path: '',
    component: NotificationMessageRxComponent,
    resolve: {
      pagingParams: ResolvePagingParams
    },
    data: {
      authorities: ['ROLE_USER'],
      defaultSort: 'id,asc',
      pageTitle: 'bjcrxApp.notificationMessage.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];
